import React, {useEffect, useState} from 'react';
import { Image, Dropdown, Spinner, Row } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { HouseFill} from 'react-bootstrap-icons';
import utils from '../../../utils';


function WorkspaceNavDropdown({currentTenant}) {

  const [ loading, setLoading ] = useState(true);
  const [ tenantList, setTenantList ] = useState('1');
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  const submitSelectedTenantHandler = (e) => {
    setLoading(true);
    if( e !== 'collapse') {
      window.location = `/?tenid=${e}`;
    }
  }

  // const getAccessToken = async () => {
  //   try {
  //     let accessToken = await getAccessTokenSilently({
  //       authorizationParams: {
  //         scope: "https://linkbridgeb2c.onmicrosoft.com/eae33b96-1854-4745-8a7d-1a75d12ab2bf/User.Read"
  //       }
  //     });
  //     return { accessToken };
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  const getTenantList = async (accToken) => {


    let res = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/workspace-reference`, {
      headers: { "Authorization": "Bearer " + accToken.accessToken }
    });
    let jsonRes = await res.json();
    setTenantList(jsonRes.workspaces);
  }

  useEffect(() => {
    if (isAuthenticated) {
      try {
        (async () => {
          setLoading(true);
          let accToken = await utils.getAccessToken(getAccessTokenSilently, user);
          await getTenantList(accToken);
          setLoading(false);
        }
        )()
      }
      catch (err) {
        console.log(err);
        setLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    !loading && currentTenant ?
      <Dropdown onSelect={(e) => submitSelectedTenantHandler(e)}>
        <Dropdown.Toggle variant="success" id="workspace-selector" className='workspace-selector tertiary-button'>
          {
            currentTenant && currentTenant.fields && currentTenant.fields.logo && currentTenant.fields.logo.url ?
              <Image className='svg-24' src={currentTenant.fields.logo.url} alt={currentTenant.fields.name} />
            : <HouseFill  style={{'float':'left'}}/>
          }
        </Dropdown.Toggle>
        <Dropdown.Menu className='wks-dd-menu'>
          <>
            {
              tenantList.map((ten) => {
                return (
                    <Dropdown.Item eventKey={ten.tenantID}>
                        {
                          ten && ten.logoSm && ten.logoSm.url ?
                          <Row>
                              <span className='logo-outline'>
                                <Image src={ten.logoSm.url} alt={ten.tenantName}/> 
                              </span>
                              <span>{ten.tenantName ? ten.tenantName : ''}</span>
                          </Row>
                          : 
                          <Row className='no-logo'>
                            {ten.tenantName ? ten.tenantName : ''}
                          </Row>
                        }
                    </Dropdown.Item>
                )
              })
            }
          </>
        </Dropdown.Menu>
      </Dropdown>
    : <Spinner animation='border' />
  )
}

export default WorkspaceNavDropdown